export default __webpack_public_path__ + "static/media/jcb.18c66f4f.svg";